import { Flash } from "~/entities/flash/types";

export const FLASH_SIGNIN_FAILURE: Flash = {
  kind: "failure",
  message: "Invalid email or password",
};

export const FLASH_SIGNIN_SUCCESS: Flash = {
  kind: "success",
  message: "You have successfully signed in",
};

export const CLOSEOUT_NO_LONGER_AVAILABLE: Flash = {
  kind: "success",
  message: "This product is no longer available as a closeout item.",
};
